import React, { useEffect, useState } from 'react';
import { twMerge } from 'tailwind-merge';
import { At, Envelope, WarningCircle } from 'phosphor-react';
import { useAppSelector, useAppDispatch } from '../../../../redux/store';
import { getSupplierInvoiceNoticeLogs } from '../../../../redux/services/invoiceNoticeLogService';
import SupplierMailFaxDeliveries from './SupplierMailFaxDeliveries';
import SupplierEmailDeliveries from './SupplierEmailDeliveries';
import SupplierDeliveryExceptions from './SupplierDeliveryExceptions';

type DeliveryTab = 'EMAIL' | 'MAIL_FAX' | 'EXCEPTIONS';

const DELIVERY_TABS: { id: DeliveryTab; label: string; icon: React.ReactNode }[] = [
  { id: 'EMAIL', label: 'Email', icon: <At size={14} /> },
  { id: 'MAIL_FAX', label: 'Mail & Fax', icon: <Envelope size={14} /> },
  { id: 'EXCEPTIONS', label: 'Delivery Exceptions', icon: <WarningCircle size={14} /> },
];

function SupplierInvoiceDelivery() {
  const dispatch = useAppDispatch();
  const currentSupplier = useAppSelector((state) => state.auth.currentSupplier);
  const { invoiceNoticeLogs, loadingList } = useAppSelector((state) => state.invoiceNoticeLogs);
  const [activeTab, setActiveTab] = useState<DeliveryTab>('EMAIL');

  // Invoice emails sent before delivery tracking only exist in the notice log.
  useEffect(() => {
    if (currentSupplier?.id) {
      dispatch(getSupplierInvoiceNoticeLogs({ supplierId: currentSupplier.id }));
    }
  }, [currentSupplier?.id, dispatch]);

  return (
    <div className="w-full h-full p-4 flex flex-col">
      <div className="flex gap-1 p-1 rounded-xl bg-gray-200 w-fit mb-3">
        {DELIVERY_TABS.filter(
          (tab) => tab.id !== 'MAIL_FAX' || currentSupplier?.isMailAndFaxDeliveryEnabled === true
        ).map((tab) => (
          <button
            key={tab.id}
            onClick={() => setActiveTab(tab.id)}
            className={twMerge(
              'flex items-center justify-center gap-1.5 h-[34px] min-w-[180px] px-5 text-xs font-medium rounded-lg border-none cursor-pointer transition-all',
              activeTab === tab.id
                ? 'bg-white text-gray-900 shadow-sm'
                : 'bg-transparent text-gray-500 hover:text-gray-800'
            )}>
            {tab.icon}
            {tab.label}
          </button>
        ))}
      </div>
      <div className="flex-1 min-h-0">
        {activeTab === 'EMAIL' && currentSupplier?.id && (
          <SupplierEmailDeliveries
            supplierId={currentSupplier.id}
            legacyNoticeLogs={invoiceNoticeLogs}
            isLegacyLoading={loadingList.includes('getSupplierInvoiceNoticeLogs')}
          />
        )}
        {activeTab === 'MAIL_FAX' &&
          currentSupplier?.id &&
          currentSupplier.isMailAndFaxDeliveryEnabled === true && (
            <SupplierMailFaxDeliveries supplierId={currentSupplier.id} />
          )}
        {activeTab === 'EXCEPTIONS' && currentSupplier?.id && (
          <SupplierDeliveryExceptions supplierId={currentSupplier.id} />
        )}
      </div>
    </div>
  );
}

export default SupplierInvoiceDelivery;
